// extracted by mini-css-extract-plugin
export default {"cont":"Table_cont__Qy5dq","wider":"Table_wider__Ea54c","table-wrapper":"Table_table-wrapper__ZusSg","table-container":"Table_table-container__ZJRLu","noData":"Table_noData__+98p8"};